export default __webpack_public_path__ + "static/media/Cambrian_300_300.3153ad92.png";